// document.addEventListener('DOMContentLoaded', function () {
//   const STORAGE_KEY = 'athaahanand_wishlist';

//   function getWishlist() {
//     try {
//       return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//     } catch (error) {
//       return [];
//     }
//   }

//   function saveWishlist(wishlist) {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
//   }

//   function isInWishlist(productId) {
//     return getWishlist().some(function (product) {
//       return String(product.id) === String(productId);
//     });
//   }

//   function updateWishlistButtons() {
//     document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
//       const productId = button.dataset.productId;
//       const active = isInWishlist(productId);

//       button.classList.toggle('is-active', active);
//       button.setAttribute('aria-pressed', active ? 'true' : 'false');

//       const title = button.dataset.productTitle || 'product';

//       button.setAttribute(
//         'aria-label',
//         active
//           ? 'Remove ' + title + ' from wishlist'
//           : 'Add ' + title + ' to wishlist'
//       );
//     });
//   }

//   function updateWishlistCount() {
//     const wishlist = getWishlist();
//     const count = wishlist.length;

//     document.querySelectorAll('[data-wishlist-count]').forEach(function (element) {
//       element.textContent = count;
//       element.classList.toggle('hidden', count === 0);
//     });

//     document.querySelectorAll('[data-wishlist-count-text]').forEach(function (element) {
//       element.textContent = count;
//     });
//   }

//   function addToWishlist(button) {
//     const wishlist = getWishlist();

//     const product = {
//       id: button.dataset.productId,
//       handle: button.dataset.productHandle,
//       title: button.dataset.productTitle,
//       url: button.dataset.productUrl,
//       image: button.dataset.productImage,
//       price: button.dataset.productPrice
//     };

//     const exists = wishlist.some(function (item) {
//       return String(item.id) === String(product.id);
//     });

//     if (!exists) {
//       wishlist.push(product);
//       saveWishlist(wishlist);
//     }

//     updateWishlistButtons();
//     updateWishlistCount();

//     button.classList.add('wishlist-added-animation');

//     setTimeout(function () {
//       button.classList.remove('wishlist-added-animation');
//     }, 400);
//   }

//   function removeFromWishlist(productId) {
//     const wishlist = getWishlist().filter(function (product) {
//       return String(product.id) !== String(productId);
//     });

//     saveWishlist(wishlist);

//     updateWishlistButtons();
//     updateWishlistCount();

//     if (typeof window.renderWishlistPage === 'function') {
//       window.renderWishlistPage();
//     }
//   }

//   document.addEventListener('click', function (event) {
//     const button = event.target.closest('[data-wishlist-button]');

//     if (button) {
//       event.preventDefault();
//       event.stopPropagation();

//       const productId = button.dataset.productId;

//       if (isInWishlist(productId)) {
//         removeFromWishlist(productId);
//       } else {
//         addToWishlist(button);
//       }

//       return;
//     }

//     const removeButton = event.target.closest('[data-wishlist-remove]');

//     if (removeButton) {
//       event.preventDefault();

//       const productId = removeButton.dataset.wishlistRemove;

//       removeFromWishlist(productId);
//     }
//   });

//   window.athaahanandWishlist = {
//     get: getWishlist,
//     save: saveWishlist,
//     add: addToWishlist,
//     remove: removeFromWishlist,
//     isInWishlist: isInWishlist,
//     updateButtons: updateWishlistButtons,
//     updateCount: updateWishlistCount
//   };

//   updateWishlistButtons();
//   updateWishlistCount();
// });



// /**
//  * Global Wishlist
//  * -----------------
//  * Client-side wishlist stored in localStorage so it persists across pages
//  * and sessions on the same browser. Works with any button that has the
//  * class `js-wishlist-toggle` plus `data-product-id` and
//  * `data-product-handle` attributes — used by the bestsellers carousel,
//  * the card-product snippet, and any future product card.
//  *
//  * Public API (window.AthWishlist):
//  *   get()                -> array of { id, handle }
//  *   add(id, handle)       -> adds a product
//  *   remove(handle)         -> removes a product
//  *   isWishlisted(handle)  -> boolean
//  *   refreshButtons()      -> re-syncs all heart buttons on the page
//  *
//  * Fires a `wishlist:change` document event on every change, with
//  * `event.detail.list` containing the updated wishlist array. The
//  * wishlist page listens for this to re-render itself.
//  */
// (function () {
//   if (window.__athWishlistInit) return;
//   window.__athWishlistInit = true;

//   var STORAGE_KEY = 'athaahanand_wishlist';

//   function getWishlist() {
//     try {
//       var raw = localStorage.getItem(STORAGE_KEY);
//       return raw ? JSON.parse(raw) : [];
//     } catch (e) {
//       return [];
//     }
//   }

//   function saveWishlist(list) {
//     try {
//       localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
//     } catch (e) {
//       /* localStorage unavailable (private mode, quota, etc.) — fail quietly */
//     }
//     updateCountBadges(list);
//     document.dispatchEvent(
//       new CustomEvent('wishlist:change', { detail: { list: list } })
//     );
//   }

//   function isWishlisted(handle) {
//     return getWishlist().some(function (item) {
//       return item.handle === handle;
//     });
//   }

//   function addToWishlist(id, handle) {
//     if (!handle) return;
//     var list = getWishlist();
//     if (!list.some(function (item) { return item.handle === handle; })) {
//       list.push({ id: id, handle: handle });
//       saveWishlist(list);
//     }
//   }

//   function removeFromWishlist(handle) {
//     var list = getWishlist().filter(function (item) {
//       return item.handle !== handle;
//     });
//     saveWishlist(list);
//   }

//   function setButtonState(button, active) {
//     button.classList.toggle('is-active', active);
//     button.setAttribute('aria-pressed', active ? 'true' : 'false');
//   }

//   function toggleFromButton(button) {
//     var handle = button.getAttribute('data-product-handle');
//     var id = button.getAttribute('data-product-id');
//     if (!handle) return;

//     if (isWishlisted(handle)) {
//       removeFromWishlist(handle);
//       setButtonState(button, false);
//     } else {
//       addToWishlist(id, handle);
//       setButtonState(button, true);
//     }
//   }

//   function updateCountBadges(list) {
//     var count = (list || getWishlist()).length;
//     document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
//       el.textContent = count;
//       el.hidden = count === 0;
//     });
//   }

//   function refreshButtons() {
//     var list = getWishlist();
//     document.querySelectorAll('.js-wishlist-toggle').forEach(function (button) {
//       var handle = button.getAttribute('data-product-handle');
//       var active = list.some(function (item) { return item.handle === handle; });
//       setButtonState(button, active);
//     });
//     updateCountBadges(list);
//   }

//   // Event delegation — works for cards added dynamically (carousels, etc.)
//   document.addEventListener(
//     'click',
//     function (event) {
//       var button = event.target.closest('.js-wishlist-toggle');
//       if (!button) return;
//       event.preventDefault();
//       event.stopPropagation();
//       toggleFromButton(button);
//     },
//     true
//   );

//   function init() {
//     refreshButtons();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   window.AthWishlist = {
//     get: getWishlist,
//     add: addToWishlist,
//     remove: removeFromWishlist,
//     isWishlisted: isWishlisted,
//     refreshButtons: refreshButtons
//   };
// })();









/**
 * Global Wishlist  (assets/wishlist.js)
 * Single source of truth. Storage key: athaahanand_wishlist  -> [{ id, handle }]
 * Works with any button: .js-wishlist-toggle[data-product-id][data-product-handle]
 *
 * window.AthWishlist: get, add(id, handle), remove(handle), toggle(id, handle),
 *                     isWishlisted(handle), count, clear, refreshButtons
 * Fires document event `wishlist:change` ({ detail: { list } }).
 */
(function () {
  if (window.AthWishlist) return;

  var STORAGE_KEY = 'athaahanand_wishlist';
  var LEGACY_HANDLE_KEY = 'athaanand_wishlist_handles'; // old card-product inline script
  var LEGACY_KEY_2 = 'shopify_wishlist';                // old wishlist-display.liquid

  function parse(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function normalize(arr) {
    var seen = {};
    return arr.map(function (i) {
      if (typeof i === 'string') return { id: null, handle: i };
      return i && i.handle ? { id: i.id || null, handle: i.handle } : null;
    }).filter(function (i) {
      if (!i || seen[i.handle]) return false;
      seen[i.handle] = true;
      return true;
    });
  }

  // One-time migration of anything saved by the old scripts
  function migrate() {
    var merged = normalize(parse(STORAGE_KEY).concat(parse(LEGACY_HANDLE_KEY), parse(LEGACY_KEY_2)));
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      localStorage.removeItem(LEGACY_HANDLE_KEY);
      localStorage.removeItem(LEGACY_KEY_2);
    } catch (e) {}
  }

  function getWishlist() { return normalize(parse(STORAGE_KEY)); }

  function updateCountBadges(list) {
    var n = String((list || getWishlist()).length);
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== n) el.textContent = n; // guard: avoids mutation loop
      el.hidden = n === '0';
    });
  }

  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    refreshButtons();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  }

  function addToWishlist(id, handle) {
    if (!handle || isWishlisted(handle)) return;
    var list = getWishlist();
    list.push({ id: id ? Number(id) : null, handle: handle });
    saveWishlist(list);
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (i) { return i.handle !== handle; }));
  }

  function toggle(id, handle) {
    if (isWishlisted(handle)) { removeFromWishlist(handle); return false; }
    addToWishlist(id, handle); return true;
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function refreshButtons() {
    var list = getWishlist();
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      setButtonState(button, list.some(function (i) { return i.handle === handle; }));
    });
    updateCountBadges(list);
  }

  // Delegated click — works for dynamically added cards and the quick-view popup
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-wishlist-toggle');
    if (!button) return;
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(button.getAttribute('data-product-id'), handle);
  }, true);

  // Re-sync hearts after filter/sort/pagination re-renders the grid
  var timer;
  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('.js-wishlist-toggle') || n.querySelector('.js-wishlist-toggle'));
      });
    });
    if (!relevant) return;
    clearTimeout(timer);
    timer = setTimeout(refreshButtons, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Keep multiple tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      refreshButtons();
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: getWishlist() } }));
    }
  });

  migrate();

  window.AthWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggle,
    isWishlisted: isWishlisted,
    count: function () { return getWishlist().length; },
    clear: function () { saveWishlist([]); },
    refreshButtons: refreshButtons
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshButtons);
  else refreshButtons();
})();